export default function importAllSvgIcons() {
    try {
        const request: __WebpackModuleApi.RequireContext =
            require.context('./icons', false, /\.svg$/)
        request.keys().forEach(request)
    } catch(err) {
        console.log(err)
    }
}
